// extracted by mini-css-extract-plugin
module.exports = {"swiperContainBox":"index_swiperContainBox__3D99L","swiperShow":"index_swiperShow__rUswg"};